export const methods = {
  async reload() {
    this.loading = true

    this.vendorRequestID = this.$route.params.id || 0

    this.loading = false
  }
}
